import { THEME } from '../../../constants/themes';

// TODO: remove hardcoded domains and fetch them from a config service, before release!

const getDomainForEnvironment = (productionDomain, environment = import.meta.env.VITE_BUILD_ENVIRONMENT) => {
  if (environment === 'dev' || environment === 'test') {
    return productionDomain.replace('.de', `-${environment}.de`);
  }

  return productionDomain;
};

export const extractThemeFromQueryParam = () => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.hash.substring(url.hash.indexOf('?') + 1));

  return params.get('theme');
};

export const extractThemeFromWebUrl = (appThemes) => {
  const hostName = window.location.hostname.toLowerCase();
  const agentDomain = getDomainForEnvironment('getbeem.de');
  const gcDomain = getDomainForEnvironment('gcbeem.de');

  if (hostName.includes(agentDomain)) {
    return THEME.AGENT;
  }

  if (hostName.includes(gcDomain)) {
    return THEME.GC;
  }

  if (hostName === 'localhost') {
    return THEME.GC;
  }

  let themeIdentifier = null;
  for (const theme of Object.values(appThemes)) {
    const { url } = theme;
    const urlName = url.includes('de') ? url.replace('.de', '') : url;
    const urlRegex = new RegExp(`(\\w*.)?${urlName}(-(dev|test))?.de`);
    if (urlRegex.test(hostName)) {
      themeIdentifier = theme.identifier;
      break;
    }
  }

  return themeIdentifier;
};

export const extractThemeFromMobilePackage = (packageId, appThemes) => {
  let themeIdentifier = null;
  for (const theme of Object.values(appThemes)) {
    if (theme.packageId === packageId) {
      themeIdentifier = theme.identifier;
      break;
    }
  }

  if (!packageId && !themeIdentifier) {
    // we extract the theme from the url
    themeIdentifier = extractThemeFromWebUrl(appThemes);
  }

  return themeIdentifier;
};

export const calculateApiBaseUrlForEnv = (apiBaseUrl, themeIdentifier) => {
  const envApiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  const env = import.meta.env.VITE_BUILD_ENVIRONMENT;
  if (env === 'production') {
    return apiBaseUrl;
  }

  if (env.includes('local')) {
    return envApiBaseUrl;
  }

  if (themeIdentifier === THEME.AGENT) {
    const agentDomain = getDomainForEnvironment('getbeem.de', env);
    return `https://api.${agentDomain}`;
  }

  if (themeIdentifier === THEME.GC) {
    const gcDomain = getDomainForEnvironment('gcbeem.de', env);
    return `https://api.${gcDomain}`;
  }

  if (envApiBaseUrl) {
    return envApiBaseUrl;
  }

  // split by .de and attach the env then back the domain
  const [baseDomain] = apiBaseUrl.split('.de');
  return `${baseDomain}-${env}.de`;
};
